var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgStreamingData = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.167,
    height: 17,
    viewBox: "0 0 14.167 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "np_notes_1560861_000000",
    transform: "translate(-10 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5625",
    "data-name": "Path 5625",
    d: "M33.181,38H26.653a.806.806,0,0,0,0,1.583h6.528a.806.806,0,0,0,0-1.583Z",
    transform: "translate(-12.833 -29.693)",
    fill: "#725d7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5626",
    "data-name": "Path 5626",
    d: "M33.181,54H26.653a.806.806,0,0,0,0,1.583h6.528a.806.806,0,0,0,0-1.583Z",
    transform: "translate(-12.833 -42.89)",
    fill: "#725d7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5627",
    "data-name": "Path 5627",
    d: "M31.542,70h-4.75a.792.792,0,1,0,0,1.583h4.75a.792.792,0,1,0,0-1.583Z",
    transform: "translate(-13.389 -56.087)",
    fill: "#725d7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5628",
    "data-name": "Path 5628",
    d: "M22.042,4.125H19.917A2.125,2.125,0,0,0,17.792,2H16.375A2.125,2.125,0,0,0,14.25,4.125H12.125A2.125,2.125,0,0,0,10,6.25V16.875A2.125,2.125,0,0,0,12.125,19h9.917a2.125,2.125,0,0,0,2.125-2.125V6.25A2.125,2.125,0,0,0,22.042,4.125Zm-6.375,0a.708.708,0,0,1,.708-.708h1.417a.709.709,0,0,1,.708.708V5.542H15.667Zm7.083,12.75a.709.709,0,0,1-.708.708H12.125a.708.708,0,0,1-.708-.708V6.25a.708.708,0,0,1,.708-.708H14.25V6.25a.709.709,0,0,0,.708.708h4.25a.709.709,0,0,0,.708-.708V5.542h2.125a.709.709,0,0,1,.708.708Z",
    fill: "#725d7b"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStreamingData, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/streamingData.6b014e09.svg";
export { ForwardRef as ReactComponent };